import { render } from "./IconTournamentCourt.vue?vue&type=template&id=955c8cca&ts=true"
import script from "./IconTournamentCourt.vue?vue&type=script&lang=ts"
export * from "./IconTournamentCourt.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__